
import { PriceList } from '@/model/PriceList';
import api from '@/service/api';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PriceListForm from './form/PriceListForm.vue';
import SavedPricelists from './SavedPricelists.vue';

@Component({
    components: {
        PriceListForm,
        SavedPricelists,
    },
})
export default class Pricelists extends Vue {
    public dialogOpen: boolean = false;
    public listOpened = false;
    public currentPricelist: PriceList | null = null;
    public loading = false;
    @Prop({
        required: false,
        type: String,
    })
    defaultPriceList!: string | null;

    public async loadPriceList(id: string) {
        this.loading = true;
        try {
            this.currentPricelist = await api.getPriceList(id);
            console.log(this.currentPricelist);
        } finally {
            this.loading = false;
            this.listOpened = false;
        }
    }

    public priceListSaved(priceList: PriceList) {
        this.$emit('priceListSaved', priceList.id);
    }

    @Watch('dialogOpen')
    onDialog(v: boolean) {
        this.$emit('dialog-state-changed', v);
        if (v && this.defaultPriceList && !this.currentPricelist) {
            this.loadPriceList(this.defaultPriceList);
        }
    }

    public openCreateNew() {
        this.listOpened = false;
        this.currentPricelist = null;
        this.dialogOpen = true;
    }

    public openList() {
        const form = this.$refs.priceListForm as PriceListForm;
        form.openList();
    }

    public onDialogOutsideClick() {
        const form = this.$refs.priceListForm as any;
        if (form && typeof form.blinkExitRun === 'function') {
            form.blinkExitRun();
        }
    }

    public onDialogClick(event: MouseEvent) {
        const cardRef = this.$refs.dialogCard as any;
        const cardEl = cardRef?.$el || cardRef;
        if (!cardEl || !(event.target instanceof Node)) {
            return;
        }
        if (!cardEl.contains(event.target)) {
            this.onDialogOutsideClick();
        }
    }
}
